
import * as React from 'react';
import { IUploaderProps, IWithFileSelectorProps } from '../../uploader/Uploader';
import { UploadAction, IUploadActionProps } from './UploadAction';
import { IFileSystemDialogProps, FileSystemDialog } from '../../fileSystemDialog/FileSystemDialog';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { PlatformDetection } from '@ms/utilities-browser/lib/PlatformDetection';
import { ActionBase } from '../../action/Action';
import { connectToItemCache } from '../../decorators/connectToItemCache';

class NoUpload extends React.PureComponent<IUploadFolderActionProps> {
    public render(): JSX.Element {
        return React.createElement(ActionBase, {});
    }
}

const platformDetection = new PlatformDetection();

const UploadFolderDialog = connectToItemCache((): Pick<IFileSystemDialogProps, 'type'> => ({ type: 'directory' }))(FileSystemDialog);

export type IUploadFolderActionProps = IDecoratedProps<IUploadActionProps, IWithFileSelectorProps, {}>;

export const UploadFolderAction: React.ComponentType<IUploadFolderActionProps> = platformDetection.isFolderUploadSupported ?
    connectToItemCache((): Pick<IUploaderProps, 'fileSelector'> =>
        ({ fileSelector: UploadFolderDialog }))(UploadAction) :
    NoUpload;
